<template>
  <div class="log-times-badge d-inline-flex" v-if="$can('create-log_times')">
    <button v-if="isAvailableAdd" class="btn button log-time btn-success" :title="isAvailableAdd ? '' : 'Please log in to Jira'" @click="showForm = true">Add Log Time</button>
    <LogTimeFormModal
      v-if="showForm"
      v-model="showForm"
      mode="create"
      :dataProps="{ user, logged_at: loggedAt ? Moment(loggedAt).format('YYYY-MM-DD') + ' ' + Moment().format('HH:mm') : null }"
      :isLoading="loading"
      :modal="true"
      :show-preloader="true"
      @submit="addLogTime"
    />
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { mapActions } from 'vuex'
import Moment from 'moment/moment'
import LogTimeFormModal from '../components/modals/LogTimeFormModal.vue'

export default {
  name: 'LogTimeAdd',
  components: {
    LogTimeFormModal
  },
  props: {
    user: {
      type: Object,
      default () {
        return null
      }
    },
    loggedAt: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      logTime: null,
      loading: false,
      showForm: false,
      form: {}
    }
  },
  watch: {
    'item': {
      deep: true,
      immediate: true,
      handler (item) {
        this.logTime = item
      }
    }
  },
  computed: {
    Moment () {
      return Moment
    },
    isAvailableAdd () {
      return !this.user || this.getUser.id === this.user.id
    }
  },
  methods: {
    ...mapActions({
      setIsModalLoading: 'finances/setIsModalLoading'
    }),
    addLogTime (data) {
      this.loading = true
      const params = this.prepareDataForRequest(data)
      this.$api.logTimes.createLogTime(params)
        .then(({ data, status }) => {
          this.$snotify.success(
            'Log time successfully created',
            'Success',
            this.$store.state.snotify
          )
          this.hideLogTimesModal()
          this.logTime = cloneDeep(data)
          this.$emit('createdLogTime', { data: this.logTime, status })
        })
        .catch(error => {
          this.errorNotifications(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    showLogTimesModal () {
      this.showForm = true
      this.form = cloneDeep(this.logTime)
    },
    hideLogTimesModal () {
      this.showForm = false
      this.setIsModalLoading(false)
    },
    prepareDataForRequest (fields) {
      let newFields = cloneDeep(fields)
      let data = {}

      for (let key in newFields) {
        const field = newFields[key]
        const name = field['name']
        const value = field['value']
        if (!value) {
          continue
        }
        if (value) {
          data[name] = typeof value === 'object' ? value[field['valueField']] : value
        }
      }
      return data
    }
  }
}
</script>

<style lang="scss" scoped>
.log-time {
  min-width: 120px;
  height: 30px;
}
</style>
